import { setLocale } from 'yup';
import { iranianLegalId, isNullOrUndefined } from '@shared/utils';

setLocale({
	// use functions to generate an error object that includes the value from the schema
	string: {
		min: ({ min }) => ({ value: 'min', action: 't', params: { field: { value: 'legalId', action: 't' }, min: { value: min } } }),
		max: ({ max }) => ({ value: 'max', action: 't', params: { field: { value: 'legalId', action: 't' }, max: { value: max } } }),
	},
});


function legalId() {
	return this
		.min(10)
		.max(11)
		.test({
			name: 'checkLegalId',
			exclusive: true,
			message: {
				value: 'inValidLegalId',
				action: 't',
			},
			test(value) {
				return isNullOrUndefined(value) || iranianLegalId(value)
			},
		})
} // legalId()

function setup(yup) {
	yup.addMethod(yup.string, 'legalId', legalId)
}

export default setup;
